import initDNA from './components/dna';

const dnaEl = document.querySelector('.js-dna');

if (dnaEl) {
    initDNA(dnaEl);
}